import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { timeout, catchError, throwError, retry } from 'rxjs';

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const isLogin = req.url.includes('/auth/local'); // Adjust as needed
  const TIMEOUT_MS = isLogin ? 120000 : 60000; // 120s for login, 60s for others
  const RETRY_COUNT = isLogin ? 0 : 1;
  const FRIENDLY_TIMEOUT_MESSAGE = 'Request timed out. Please try again.';

  return next(req).pipe(
    retry(RETRY_COUNT),
    timeout(TIMEOUT_MS),
    catchError((err) => {
      if (err?.name === 'TimeoutError') {
        const normalized = new HttpErrorResponse({
          status: 408,
          statusText: 'Request Timeout',
          url: req.url,
          error: { message: FRIENDLY_TIMEOUT_MESSAGE }
        });
        return throwError(() => normalized);
      }
      return throwError(() => err);
    })
  );
};